











































































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { NavBar, Field, Button, Dialog, Form } from "vant";
import WeMixin from "@/components/weMixin";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
  },
})
export default class MerchantCouponHome extends mixins(WeMixin) {
  private showHome: boolean = false;
  private checkCus: boolean = true;
  private isShowError: boolean = false;
  private showText: string = "";
  private buttonActive: boolean = false;
  private phonenum: string = "";
  private showQr: boolean = false;
  private showConfirmButton: boolean = false;

  private errmsg: string = "";
  private errDialogFalse: boolean = false;

  protected created() {
    // 添加返回事件监听
    // this.getCustomerInfo();
    this.errDialogFalse = true;
    this.errmsg = "请在苏邮惠小程序上进行操作";
    this.checkCus = true;
    this.isShowError = false;
    this.showHome = false;
  }

  protected afterSubscribe() {
    location.reload();
  }

  protected getCustomerInfo() {
    api.post("/weixinmp/xsyx/myuser/checkIsSubscribe", {}).then((res: any) => {
      if (!res.data) {
        this.checkCus = false;
        this.isShowError = true;
        this.showText =
          "请先关注“江苏邮政微金融”公众号，再退回点击“下方红字”参加抽奖，抽奖结果同步通过公众号发送，您可随时查看。";
        this.showQr = true;
        this.showConfirmButton = true;
      } else {
        api
          .post("/weixinmp/xsyx/merchant/checkMerchantRaffleRepeat", {})
          .then((res1: any) => {
            if (!res1.data) {
              this.checkCus = false;
              this.isShowError = true;
              this.showText = "本年度已兑奖，无法重复参与";
            } else {
              api
                .post(
                  "/weixinmp/xsyx/merchant/checkMerchantRaffleRepeat15Day",
                  {}
                )
                .then((res2: any) => {
                  if (!res2.data) {
                    this.checkCus = false;
                    this.isShowError = true;
                    this.showText = "15天内已抽奖，无法重复参与";
                  } else {
                    api
                      .get("/weixinmp/xsyx/myuser/getCustomerInfo")
                      .then((res3: any) => {
                        if (res3.data.flag === "0") {
                          const merchantQrinfoId =
                            this.$route.params.merchantQrinfId;
                          this.$router.push(
                            "/main/merchant/merchantRaffle/" +
                              merchantQrinfoId +
                              "&" +
                              res3.data.phone
                          );
                        } else {
                          this.showHome = true;
                        }
                      });
                  }
                });
            }
          });
      }
    });
  }

  protected toRaffle() {
    if (!this.phonenum) {
      this.$toast("请输入手机号码");
      return;
    }
    const reg = /^1\d{10}$/;
    if (!reg.test(this.phonenum)) {
      this.$toast("手机号格式不正确");
      return;
    }
    const merchantQrinfoId = this.$route.params.merchantQrinfId;
    api
      .post("/weixinmp/xsyx/merchant/checkPhoneBind", { phone: this.phonenum })
      .then((res: any) => {
        if (res.data.flag) {
          this.$router.push(
            "/main/merchant/merchantRaffle/" +
              merchantQrinfoId +
              "&" +
              this.phonenum
          );
        } else {
          this.$toast("输入的手机号已被注册");
          return;
        }
      });
  }
}
